const hasOwn = Object.prototype.hasOwnProperty;

const buildProductMatrixIndex = (productList, matrix) => {
  const map = {};
  (productList || []).forEach((product) => {
    (product.Varieties || []).forEach((variety) => {
      const values = (matrix && matrix[variety.id]) || [];
      const byId = {};
      (variety.VarietyPrices || []).forEach((price, index) => {
        const priceId = price?.id;
        if (priceId == null) return;
        if (typeof values[index] === 'undefined') return;
        byId[String(priceId)] = values[index];
      });
      map[variety.id] = { byId, byIndex: values };
    });
  });
  return map;
};

export const mergeProductMatrix = (nextProducts, previousProducts, previousMatrix, fillValue = 0) => {
  const previousMap = buildProductMatrixIndex(previousProducts, previousMatrix);
  const result = {};
  (nextProducts || []).forEach((product) => {
    (product.Varieties || []).forEach((variety) => {
      const prices = variety.VarietyPrices || [];
      const row = new Array(prices.length).fill(fillValue);
      const previousEntry = previousMap[variety.id];
      prices.forEach((price, index) => {
        const priceId = price?.id;
        if (priceId != null && previousEntry?.byId && hasOwn.call(previousEntry.byId, String(priceId))) {
          row[index] = previousEntry.byId[String(priceId)];
          return;
        }
        if (previousEntry?.byIndex && typeof previousEntry.byIndex[index] !== 'undefined') {
          row[index] = previousEntry.byIndex[index];
        }
      });
      result[variety.id] = row;
    });
  });
  return result;
};
